import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CLASS_TAG_TYPES } from '@classCreation/data/classTagTypes';
import { classTagSelector } from '@classCreation/selectors/createClassForm';
import { setClassTag } from '@classCreation/store/createClassForm';
import Select from 'components/Select';
import styles from './ClassTagField.module.scss';

export default function ClassTagField({ classTag, actions, isEditing }) {
  const dispatch = useDispatch();
  const classTagState = useSelector(classTagSelector);

  const handleClassTagChange = useCallback(
    (newClassTag) => {
      dispatch(setClassTag(newClassTag));
    },
    [dispatch]
  );

  useEffect(() => {
    if (classTag) {
      const classTagValueObj =
        CLASS_TAG_TYPES.find((tag) => tag.label === classTag) ||
        CLASS_TAG_TYPES[0];
      dispatch(setClassTag(classTagValueObj));
    }
  }, [classTag, dispatch]);

  return (
    <div className="m-b-s">
      <div className="m-v-xxs">
        <label className="hint">Class Tag</label>
        {!isEditing && actions}
      </div>
      <Select
        className={styles.dropdown}
        placeholder={`Class Tag Type`}
        value={classTagState}
        isDisabled={!isEditing}
        options={CLASS_TAG_TYPES}
        onChange={handleClassTagChange}
      />
    </div>
  );
}
